import React from 'react';
import { CardExpiryElement } from '@stripe/react-stripe-js';

import { VpStripeInput } from '../..';

export const StripeCardExpireInput = () => {
  return (
    <VpStripeInput stripeElement={CardExpiryElement} placeholder="Expiration Date" name="expDate" />
  );
};



// WEBPACK FOOTER //
// ./src/vp-ui/form-fields/stripe-elements/StripeCardExpireInput.jsx